import ClienteService from "@/services/ClienteService";

export const cliente = {
  namespaced: true,
  state: {
    cliente: {},
  },
  actions: {
    getCliente({ commit }, payload) {
      return ClienteService.GetCliente(payload).then(
        (cliente) => {
          return Promise.resolve(cliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCliente({ commit }, payload) {
      return ClienteService.PostCliente(payload).then(
        (cliente) => {
          return Promise.resolve(cliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCliente({ commit }, payload) {
      return ClienteService.PutCliente(payload).then(
        (cliente) => {
          return Promise.resolve(cliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCliente({ commit }, payload) {
      return ClienteService.DeleteCliente(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getClienteOData({ commit }, payload) {
      return ClienteService.GetClienteOData(payload).then(
        (cliente) => {
          return Promise.resolve(cliente);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    validate({ commit }, payload) {
      return ClienteService.Validate(payload).then(
        (cliente) => {
          return Promise.resolve(cliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    converter({ commit }, payload) {
      return ClienteService.Converter(payload).then(
        (cliente) => {
          return Promise.resolve(cliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default cliente;
